// Importes y fechas como se escriben en España: «1.234,50 €» y «17/10/2026». Lo que ve el cliente o la
// empresa no lleva punto decimal ni fechas ISO.
// El separador de miles se pone a mano: con Intl, «es-ES» no agrupa los números de cuatro cifras salvo
// con useGrouping «always» (Intl de ES2023), que los navegadores anteriores no conocen («1234,50 €»).
// Intl sigue dando el redondeo, la coma decimal, el signo y el «€».
const EUR = new Intl.NumberFormat("es-ES", {
  style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: false,
});

const conMiles = (entero) => entero.replace(/\B(?=(\d{3})+$)/g, ".");

export function eur(n) {
  const v = Number(n);
  return EUR.format(Number.isFinite(v) ? v : 0).replace(/\d+(?=,)/, conMiles);
}

// «2026-10-17» o un ISO con hora → «17/10/2026». La parte de fecha de un ISO se toma tal cual (sin
// pasar por la zona del navegador): una fecha de recogida no cambia de día según dónde se mire.
export function fecha(iso) {
  if (!iso) return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso));
  return m ? `${m[3]}/${m[2]}/${m[1]}` : String(iso);
}

// Un instante (ISO con hora, en UTC) → «15/10/2026 00:30» en la zona de quien mira (la de su navegador), como el
// resto de instantes del panel; no necesariamente la de la empresa.
// `timeZone` solo lo fijan los tests. Sin fecha, o con una que no se entiende, «—».
export function fechaHora(iso, timeZone) {
  const t = Date.parse(iso || "");
  if (!Number.isFinite(t)) return "—";
  const partes = Object.fromEntries(new Intl.DateTimeFormat("es-ES", {
    day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hourCycle: "h23", timeZone,
  }).formatToParts(new Date(t)).map((p) => [p.type, p.value]));
  return `${partes.day}/${partes.month}/${partes.year} ${partes.hour}:${partes.minute}`;
}
